<!--
2022-10-19 Matt 一元夺宝规则，读取静态文件内容
-->
<template>
  <div class="RulePage">
    <TopBack :title="$t('lang.treasure.rules')" />

    <img
      class="introduceImg"
      alt="agent-rules"
      src="https://s3.ap-northeast-1.amazonaws.com/media.web.pgebet.com/promotions/promotion_one_rupee_treasure.jpg"
    >

    <div class="rules" v-html="ruleHtml">
    </div>
  </div>
</template>

<script>
import axios from 'axios'

import TopBack from '@/components/TopBack/index'

export default {
  name: 'TreasureRule',
  components: {
    TopBack
  },
  data () {
    return {
      ruleHtml: ''
    }
  },
  watch: {
    '$store.state.locale': function () {
      this.loadData()
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData: function () {
      let languagePre = this.$store.state.locale
      languagePre = languagePre === 'EN' ? '' : '-' + languagePre
      const htmlFileURL = location.origin + '/static/promotionRules/treasure-' + this.$store.state.internation + languagePre + '.html'
      axios.get(htmlFileURL).then(res => {
        if (res.data != null) {
          this.ruleHtml = res.data
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .RulePage {
    padding:56px 0 70px 0;
    background-color: rgba(0,0,0,.9);
    height: 92vh;
    overflow-y: hidden;
    text-align: center;

    .introduceImg {
      width: 90vw;
      margin: 20px auto 0;
      border-radius: 5px;
    }

    .rules {
      height: 70vh;
      width: 90vw;
      margin: 5px auto 20px;
      padding-bottom: 220px;
      overflow-y: scroll;
      text-align: left;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Treasure/rules.vue